import { render, staticRenderFns } from "./agents-container.vue?vue&type=template&id=8e39d20c"
import script from "./agents-container.vue?vue&type=script&lang=js"
export * from "./agents-container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports